module.exports = __webpack_public_path__ + "media/images/flags/16/South-Africa-0ed7259b6b8bbf334225976bd4ebb0f3.png";